"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = exports.classes = void 0;
const Button_1 = require("@mui/material/Button");
const styles_1 = require("@mui/material/styles");
const PREFIX = "Navigation";
exports.classes = {
    offset0: `${PREFIX}-offset0`,
    offset1: `${PREFIX}-offset1`,
    offset2: `${PREFIX}-offset2`,
    offset3: `${PREFIX}-offset3`,
    offset4: `${PREFIX}-offset4`,
    offset5: `${PREFIX}-offset5`,
    navigationList: `${PREFIX}-navigationList`,
    footer: `${PREFIX}-footer`,
    show: `${PREFIX}-show`,
    backNavigation: `${PREFIX}-backNavigation`,
    backButton: `${PREFIX}-backButton`,
    chevronLeft: `${PREFIX}-chevronLeft`,
    chevronRight: `${PREFIX}-chevronRight`,
    separator: `${PREFIX}-separator`,
    mainMenuTitle: `${PREFIX}-mainMenuTitle`,
    mainMenuTitleWrapper: `${PREFIX}-mainMenuTitleWrapper`,
    navigationListType: `${PREFIX}-navigationListType`,
    image: `${PREFIX}-image`,
    iconWrapper: `${PREFIX}-iconWrapper`,
    utilities: `${PREFIX}-utilities`,
    languageButtonContent: `${PREFIX}-languageButtonContent`,
    languageIcon: `${PREFIX}-languageIcon`,
    navigationListButton: `${PREFIX}-navigationListButton`,
    active: `${PREFIX}-active`,
    outline: `${PREFIX}-outline`
};
exports.Root = (0, styles_1.styled)("nav")(({ theme }) => ({
    height: "100%",
    margin: "auto",
    maxWidth: theme.breakpoints.values.xl,
    overflowX: "hidden",
    position: "relative",
    zIndex: 10,
    [theme.breakpoints.up(1030)]: {
        margin: "0 50px",
        top: "16px"
    },
    [`@media (min-width: ${theme.breakpoints.values.xl + 100}px)`]: {
        margin: "auto"
    },
    [`.${exports.classes.navigationList}`]: {
        [`.${exports.classes.navigationList}`]: {
            left: "calc(100% + 1px)"
        },
        [`.${exports.classes.footer}`]: {
            zIndex: 0,
            [`.${exports.classes.navigationListButton}`]: {
                [`.${exports.classes.outline}`]: {
                    color: theme.colours.cyan500,
                    borderColor: `${theme.colours.cyan500}80`,
                    "&:hover": {
                        backgroundColor: `${theme.colours.cyan600}0a`
                    }
                }
            },
            [theme.breakpoints.up(1030)]: {
                left: "400%"
            },
            [theme.breakpoints.down(1030)]: {
                display: "none"
            }
        },
        "& > ul": {
            height: "100%",
            listStyle: "none",
            overflowX: "hidden",
            overflowY: "auto",
            [theme.breakpoints.up(1030)]: {
                height: "calc(100% - 1rem)"
            }
        },
        backgroundColor: theme.colours.white,
        boxSizing: "border-box",
        display: "none",
        height: "100%",
        position: "absolute",
        width: "100%",
        top: 0,
        zIndex: 1,
        [theme.breakpoints.up(1030)]: {
            borderRight: `1px solid ${theme.colours.storm}`
        }
    },
    [`> .${exports.classes.navigationList}`]: {
        // The first .NavigationList only visible on mobile
        left: "0%",
        transition: "left 0.2s ease-out",
        [theme.breakpoints.up(1030)]: {
            borderRight: "none",
            width: "25%",
            marginLeft: "-25%"
        }
    },
    [`.${exports.classes.navigationListButton}`]: {
        textAlign: "left",
        justifyContent: "space-between",
        alignItems: "normal",
        "& svg": {
            height: "30px",
            margin: "-7px 0"
        },
        [`&:hover .${exports.classes.chevronLeft}, .${exports.classes.active} .chevronLeft, &:hover .${exports.classes.chevronRight}, .${exports.classes.active} .${exports.classes.chevronRight}`]: {
            transform: "translateX(0px)"
        },
        [`.${Button_1.buttonClasses.startIcon}, .${Button_1.buttonClasses.endIcon}`]: {
            display: "initial",
            marginLeft: 0,
            "& [data-name='bg block']": {
                fill: "none"
            },
            "& svg": {
                maxWidth: "100px",
                [theme.breakpoints.up("xl")]: {
                    maxWidth: "130px"
                }
            }
        },
        color: theme.colours.slate,
        fontSize: "1rem",
        lineHeight: 1,
        margin: "0 10px",
        padding: "12px 16px",
        transition: "background-color 120ms cubic-bezier(0.4, 0, 0.2, 1)",
        width: "calc(100% - 20px)",
        fill: "transparent",
        [theme.breakpoints.up(1030)]: {
            margin: 0,
            width: "100%"
        },
        "&:hover": {
            color: theme.colours.charcoal
        }
    },
    [`.${exports.classes.offset0}`]: {
        left: "0 !important",
        [theme.breakpoints.up(1030)]: {
            left: "initial !important"
        }
    },
    [`.${exports.classes.offset1}`]: {
        left: "-100% !important",
        [theme.breakpoints.up(1030)]: {
            left: "initial !important"
        }
    },
    [`.${exports.classes.offset2}`]: {
        left: "-200% !important",
        [theme.breakpoints.up(1030)]: {
            left: "initial !important"
        }
    },
    [`.${exports.classes.offset3}`]: {
        left: "-300% !important",
        [theme.breakpoints.up(1030)]: {
            left: "initial !important"
        }
    },
    [`.${exports.classes.offset4}`]: {
        left: "-400% !important",
        [theme.breakpoints.up(1030)]: {
            left: "initial !important"
        }
    },
    [`.${exports.classes.show}`]: {
        display: "block"
    },
    [`.${exports.classes.backNavigation}`]: {
        [theme.breakpoints.up(1030)]: {
            display: "none"
        }
    },
    [`.${exports.classes.backButton}`]: {
        fontWeight: "bold",
        marginTop: "10px !important",
        padding: "12px 10px 12px 2px !important",
        width: "250px !important",
        justifyContent: "start !important",
        "& svg": {
            width: "24px !important"
        }
    },
    [`.${exports.classes.chevronLeft}`]: {
        height: "1.5rem !important",
        transition: "transform 120ms cubic-bezier(0.4, 0, 0.2, 1)",
        transform: "translateX(10px)",
        marginRight: "15px !important"
    },
    [`.${exports.classes.chevronRight}`]: {
        height: "1.5rem !important",
        transition: "transform 120ms cubic-bezier(0.4, 0, 0.2, 1)",
        transform: "translateX(-10px)"
    },
    [`.${exports.classes.separator}`]: {
        border: "none",
        borderTop: `1px solid ${theme.colours.storm}`,
        margin: "12px 16px"
    },
    [`.${exports.classes.mainMenuTitle}`]: {
        borderBottom: `1px solid ${theme.colours.alabaster}`,
        fontWeight: "bold",
        margin: "15px 10px 10px",
        padding: "0 46px 19px 10px",
        width: "50%"
    },
    [`.${exports.classes.mainMenuTitleWrapper}`]: {
        [theme.breakpoints.up(1030)]: {
            display: "none"
        }
    },
    [`.${exports.classes.navigationListType}`]: {
        "& svg": {
            height: "2rem"
        },
        margin: "16px",
        padding: "0 10px",
        [theme.breakpoints.up(1030)]: {
            padding: 0,
            margin: "16px"
        }
    },
    [`.${exports.classes.image}`]: {
        maxWidth: "100%",
        margin: "0 0 24px 16px",
        display: "block"
    },
    [`.${exports.classes.iconWrapper}`]: {
        display: "inline-block",
        width: "100px",
        [theme.breakpoints.up("xl")]: {
            width: "130px"
        }
    },
    [`.${exports.classes.utilities}`]: {
        backgroundColor: theme.colours.pearl,
        margin: "10px 0 !important",
        padding: "10px 0 !important"
    },
    [`.${exports.classes.languageButtonContent}`]: {
        display: "flex",
        justifyContent: "center",
        fontWeight: 500
    },
    [`.${exports.classes.languageIcon}`]: {
        marginRight: "10px",
        width: "20px"
    },
    [`.${exports.classes.active}`]: {
        backgroundColor: "rgba(59, 59, 59, 0.04)"
    }
}));
//# sourceMappingURL=data:application/json;base64,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